import moment from 'moment';
import React from 'react'
import { Badge, Card, Modal, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { PropagateLoader } from 'react-spinners';
// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';

export default function AttendanceModal(props) {

    const { showAttendance, setShowAttendance, attendanceLoading } = props;

    const data = useSelector(state => state?.attendanceHistoryList?.data?.data)

    const handleClose = () => setShowAttendance(false);

    return (
        <>
            <Modal show={showAttendance} onHide={handleClose} size='lg' centered backdrop='static'>
                <Modal.Header closeButton>
                    <Modal.Title>Attendance History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {attendanceLoading ?
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                        :
                        <>
                            <div className="row">
                                <div className="col">
                                    <Card body className='bg-primary-subtle'>
                                        <div className='fs-6 fw-semibold text-primary-emphasis'>Working Days</div>
                                        <div className='fw-bold fs-4 text-primary-emphasis'>{data?.length ? data?.[0]?.working_days : '-'}</div>
                                    </Card>
                                </div>
                                <div className="col">
                                    <Card body className='bg-success-subtle'>
                                        <div className='fs-6 fw-semibold text-success-emphasis'>Leaves Taken</div>
                                        <div className='fw-bold fs-4 text-success-emphasis'>{data?.length ? data?.[0]?.leave_taken : '-'}</div>
                                    </Card>
                                </div>
                                <div className="col">
                                    <Card body className='bg-danger-subtle'>
                                        <div className='fs-6 fw-semibold text-danger-emphasis'>Leaves Left</div>
                                        <div className='fw-bold fs-4 text-danger-emphasis'>{data?.length ? data?.[0]?.leave_left : '-'}</div>
                                    </Card>
                                </div>
                                <div className="col">
                                    <Card body className='bg-warning-subtle'>
                                        <div className='fs-6 fw-semibold text-warning-emphasis'>Holidays</div>
                                        <div className='fw-bold fs-4 text-warning-emphasis'>{data?.length ? data?.[0]?.holidays : '-'}</div>
                                    </Card>
                                </div>
                            </div>

                            <Table striped bordered hover size="sm" className='mt-2'>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Punch In</th>
                                        <th>Punch Out</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.length ?
                                        data?.map((val, index) => (
                                            <tr key={index}>
                                                <td>{val?.ddate && moment(val?.ddate).format('DD/MM/YYYY')}</td>
                                                <td>{val?.vpunch_In ? moment(val?.vpunch_In, "HH:mm:ss.SSS").format("HH:mm") : '-'}</td>
                                                <td>{val?.vpunch_Out ? moment(val?.vpunch_Out, "HH:mm:ss.SSS").format("HH:mm") : '-'}</td>
                                                <td>
                                                    {val?.vstatus === 'Holiday' ?
                                                        <Badge pill bg="warning">
                                                            {val?.vstatus}
                                                        </Badge> :
                                                        val?.vstatus === 'Present' ?
                                                            <Badge pill bg="success">
                                                                {val?.vstatus}
                                                            </Badge> :
                                                            val?.vstatus === 'Absent' ?
                                                                <Badge pill bg="danger">
                                                                    {val?.vstatus}
                                                                </Badge> :
                                                                val?.vstatus === 'Leave' ?
                                                                    <Badge pill bg="info">
                                                                        {val?.vstatus}
                                                                    </Badge> : '-'
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <tr className='text-center'>
                                            <td colSpan={4}>{'Data Not Found'}</td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </>
                    }

                    {/* <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin]}
                        initialView='dayGridMonth'
                        initialDate="2025-03"
                        headerToolbar={{
                            left: "title",
                            right: 'prev next'
                        }}
                        height={500}
                        weekends={true}
                        events={[
                            { title: 'Present', date: '2025-03-01' },
                            { title: 'Present', date: '2025-03-02' },
                            { title: 'Present', date: '2025-03-03' },
                            { title: 'Present', date: '2025-03-04' },
                            { title: 'Absent', date: '2025-03-05' },
                            { title: 'Present', date: '2025-03-06' },
                            { title: 'Present', date: '2025-03-07' }
                        ]}
                        eventDidMount={(info) => {
                            if (info.event.title === "Absent") {
                                info.el.style.backgroundColor = "red";
                                info.el.style.color = "white";
                            } else if (info.event.title === "Present") {
                                info.el.style.backgroundColor = "green";
                                info.el.style.color = "white";
                            }
                        }}
                        dayMaxEventRows={2}
                        firstDay={1}
                    /> */}
                </Modal.Body>
            </Modal>
        </>
    );
}
